import React from 'react'
import { Input, Form } from 'antd'
import { isDesktop } from 'react-device-detect'
import FormStateType from '../../FormState.type'

const { TextArea } = Input

type PropTypes = {
  formState: FormStateType
  name: string
  setFormState: (newState: object) => void
}

export const WitnessForm = ({ name, formState, setFormState }: PropTypes) => {
  const [form] = Form.useForm()
  return (
    <div className="signature-modal-vertial-center">
      <p style={{ fontWeight: 700, fontSize: 16 }}>
        {formState.capacity
          ? `Who will sign as a witness?`
          : `Who will sign on behalf of ${name}`}
      </p>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          name: formState.name,
          relationship: formState.relationship,
          reason: formState.reason,
        }}
        onValuesChange={(change, fields) => {
          setFormState(fields)
        }}
      >
        <div style={isDesktop ? styles.desktopRow : {}}>
          <Form.Item label="Full Name" name="name">
            <Input />
          </Form.Item>
          <Form.Item
            label="Relationship"
            name="relationship"
            style={{ marginLeft: isDesktop ? 12 : 0 }}
          >
            <Input />
          </Form.Item>
        </div>
        {formState.capacity && (
          <Form.Item
            label={`Why is ${name} unable to sign?`}
            name="reason"
            style={{ marginTop: 10 }}
          >
            <TextArea />
          </Form.Item>
        )}
      </Form>
    </div>
  )
}

const styles = {
  desktopRow: {
    display: 'flex',
    // flexDirection: 'row',
  },
}

export default WitnessForm
